module.exports = __webpack_public_path__ + "assets/ed6959393dfd6e8fa3f3213eff3908e5.png";